import React from 'react';
import AdminContainer from '../root_app';
import { mountApp } from './utils/mount-app';

mountApp(<AdminContainer />);
